import { useState } from "react";
import axios from "axios";
import { Check, Send } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const SubscriberForm = ({ variant = "footer" }) => {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (!/^\S+@\S+\.\S+$/.test(email)) {
      setError("Please share a valid email.");
      return;
    }
    setSubmitting(true);
    try {
      await axios.post(`${API}/subscribers`, {
        email: email.trim(),
        name: name.trim() || null,
      });
      setDone(true);
      setEmail("");
      setName("");
    } catch (e2) {
      setError("Couldn't subscribe right now. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  const isFooter = variant === "footer";

  if (done) {
    return (
      <div
        className="inline-flex items-center gap-2 text-sm text-[#4A6B53]"
        data-testid="subscriber-form-success"
      >
        <Check size={15} /> Subscribed — I&apos;ll write when there&apos;s something to share.
      </div>
    );
  }

  return (
    <form
      onSubmit={onSubmit}
      className={isFooter ? "mt-3 space-y-2" : "space-y-3"}
      data-testid="subscriber-form"
    >
      {!isFooter && (
        <input
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Your name (optional)"
          className="w-full bg-[#FAF9F6] border border-[#D8D3CC] rounded-sm px-3 py-2 text-sm text-[#2C2A28] placeholder-[#5C5852]/60 field-ring transition-colors"
          data-testid="subscriber-input-name"
        />
      )}
      <div className={isFooter ? "flex gap-2" : "flex gap-2"}>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="your@email.com"
          className="flex-1 bg-[#FAF9F6] border border-[#D8D3CC] rounded-sm px-3 py-2 text-sm text-[#2C2A28] placeholder-[#5C5852]/60 field-ring transition-colors"
          data-testid="subscriber-input-email"
          required
        />
        <button
          type="submit"
          disabled={submitting}
          className="inline-flex items-center gap-1.5 px-3.5 py-2 rounded-sm bg-[#4A6B53] text-[#FAF9F6] hover:bg-[#3A5441] transition-colors duration-300 text-xs tracking-wide disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap"
          data-testid="subscriber-submit"
        >
          {submitting ? "…" : "Subscribe"}
          {!submitting && <Send size={12} />}
        </button>
      </div>
      {error && (
        <p className="text-xs text-[#CC4A52]" data-testid="subscriber-error">
          {error}
        </p>
      )}
    </form>
  );
};

export default SubscriberForm;
